import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: "#fff",
  },
  title: {
    margin: theme.spacing.unit,
    color: "#fff"
  }
});

const Header = ({ classes, title }) => {
  return (
    <div className={classes.root}>
      <Avatar aria-label="Timecard" className={classes.avatar}>
        <Typography variant="headline">T</Typography>
      </Avatar>
      <Typography variant="display1" className={classes.title}>{title}</Typography>
    </div>
  );
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/admin/Timecards/Dialog/Header.jsx